import { useSelector } from 'react-redux';

import { ListMlsesQuery_webMarket_listMlses_mlses_mlses } from 'src/api/queries/__generated__/ListMlsesQuery';
import { useGetMlsesQuery } from 'src/store/api';
import { address as getAddress } from 'src/store/sellerFlow/selectors';

import SelectInput, { SelectInputProps } from './SelectInput';

type MlsNamesSelectInputProps = {
  question: SelectInputProps['question'];
  value?: string;
};

const builderToOption = (mls: ListMlsesQuery_webMarket_listMlses_mlses_mlses) => ({
  label: mls.displayName,
  value: mls.identifier,
});

const MlsNamesSelectInput: React.FC<MlsNamesSelectInputProps> = ({ question, value }) => {
  const address = useSelector(getAddress);
  const { data, isLoading } = useGetMlsesQuery(address.postalCode, {
    skip: address.postalCode == '',
  });

  return (
    <SelectInput
      question={{ ...question, options: data ? data.map(builderToOption) : [] }}
      isLoading={isLoading}
      value={value}
    />
  );
};

export default MlsNamesSelectInput;
